import angular from 'angular';
import '../core.module';

class StorageService {
  get(key) {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return raw;
    }
  }

  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key) {
    localStorage.removeItem(key);
  }
}

angular.module('app.core').service('StorageService', StorageService);

export default StorageService;
